import { useState } from 'react';
import { createCheckoutSession } from '../services/api';

export function LimitReachedState() {
  const [isLoading, setIsLoading] = useState(false);

  const handleUpgrade = async () => {
    setIsLoading(true);
    try {
      const url = await createCheckoutSession();
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('Checkout session error:', err);
      alert('Unable to start checkout. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      marginTop: '16px',
      padding: '20px',
      background: 'var(--warning-bg)',
      border: '1px solid var(--warning-border)',
      borderRadius: '12px',
    }}>
      <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--warning-text)', marginBottom: '4px', margin: 0 }}>
        Daily limit reached
      </p>
      <p style={{ fontSize: '13px', color: 'var(--warning-text)', opacity: 0.8, lineHeight: 1.5, margin: 0, marginTop: '4px' }}>
        You've used all 3 free rewrites today. Upgrade to Pro for unlimited rewrites.
      </p>
      <button
        onClick={handleUpgrade}
        disabled={isLoading}
        style={{
          marginTop: '14px',
          padding: '10px 20px', borderRadius: '10px', border: 'none',
          background: isLoading ? 'rgba(0,212,255,0.4)' : 'var(--accent)',
          color: 'var(--btn-primary-text)',
          fontSize: '13px', fontWeight: 600,
          fontFamily: "'Outfit', sans-serif",
          cursor: isLoading ? 'not-allowed' : 'pointer',
          boxShadow: isLoading ? 'none' : '0 4px 15px rgba(0,212,255,0.25)',
        }}
      >
        {isLoading ? 'Loading...' : 'Upgrade to Pro — $49/month'}
      </button>
    </div>
  );
}
